import {Col, Row} from 'react-bootstrap';

const DetailField = ({
  label, xs = 12, sm = 6, md = 6, lg = 3, labelClassName = '', valueClassName = '', children
}) => (
  <Row>
    <Col className={labelClassName} lg={lg} md={md} sm={sm} xs={xs}>
      {label}
      :
    </Col>
    <Col className={valueClassName} lg={lg} md={md} sm={sm} xs={xs}>
      {children}
    </Col>
  </Row>
);

export default DetailField;
